export interface ICalendlyAPI {
    active: boolean;
    description: string | null;
    duration: number;
    id: string;
    name: string;
    slug: string;
    userSlug: string;
}

export interface ICalendlyData {
    key?: string;
    importedType?: string;
    eventTypes?: ICalendlyAPI[];
}
